"use client";

import { useCallback, useEffect, useState } from "react";
import { getMe, logout as logoutApi, type AuthUser } from "@/lib/auth";

// Detects the shared .encrata.com app session from public marketing pages so the
// navbar can swap its CTAs. The session cookie is issued by the backend API (not
// this site or the app's Next server) and sent cross-subdomain with credentials,
// so getMe() resolves the same user the dashboard sees. Optimistic logged-out:
// signed-out visitors render immediately and never flicker; a live session swaps
// in once /me answers.
export function useAppSession() {
  const [user, setUser] = useState<AuthUser | null>(null);

  useEffect(() => {
    let active = true;
    getMe().then((u) => {
      if (active) setUser(u);
    });
    return () => {
      active = false;
    };
  }, []);

  // Ends the shared session at the backend, then flips CTAs back to signed-out.
  const logout = useCallback(async () => {
    try {
      await logoutApi();
    } finally {
      setUser(null);
    }
  }, []);

  return { user, logout };
}
